/* Né de maquette/assets/site.js ; la maquette est abandonnée : ce fichier se modifie ici (ne plus lancer scripts/theme_assets.py) */
// Essentiel Apiculture — maquette v2 : langue FR/EN, menu « ⋯ », avis, statut d'ouverture, tri, galerie, recherche.
(function () {
  var doc = document.documentElement;
  var memo = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
               set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var langue = (doc.lang || "fr").slice(0, 2) === "en" ? "en" : "fr";   // Shopify : langue de la page

  // --- statut d'ouverture (heure de Paris), dans la langue choisie ; fermé les jours fériés et les jours notés
  // dans « Fermetures exceptionnelles » (réglages du thème)
  var H = window.HORAIRES || [];
  var JOURS = { fr: ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"], en: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] };
  var parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", weekday: "long", year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date());
  var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
  var jour = JOURS.en.indexOf(get("weekday"));
  var min = parseInt(get("hour"), 10) * 60 + parseInt(get("minute"), 10);
  var JOUR = 864e5, auj = Date.UTC(+get("year"), +get("month") - 1, +get("day"));   // dates = minuit UTC du jour à Paris

  // jours fériés en France (Pâques calculé chaque année)
  var feries = {};
  function joursFeries(a) {
    if (feries[a]) return feries[a];
    var g = a % 19, s = Math.floor(a / 100), u = a % 100, h = (19 * g + s - Math.floor(s / 4) - Math.floor((s - Math.floor((s + 8) / 25) + 1) / 3) + 15) % 30,
        l = (32 + 2 * (s % 4) + 2 * Math.floor(u / 4) - h - u % 4) % 7, m = Math.floor((g + 11 * h + 22 * l) / 451),
        paques = Date.UTC(a, Math.floor((h + l - 7 * m + 114) / 31) - 1, (h + l - 7 * m + 114) % 31 + 1), f = {};
    [[Date.UTC(a, 0, 1), "jour de l’an", "New Year’s Day"], [paques + JOUR, "lundi de Pâques", "Easter Monday"],
     [Date.UTC(a, 4, 1), "fête du Travail", "Labour Day"], [Date.UTC(a, 4, 8), "8 mai 1945", "VE Day"],
     [paques + 39 * JOUR, "Ascension", "Ascension Day"], [paques + 50 * JOUR, "lundi de Pentecôte", "Whit Monday"],
     [Date.UTC(a, 6, 14), "fête nationale", "Bastille Day"], [Date.UTC(a, 7, 15), "Assomption", "Assumption Day"],
     [Date.UTC(a, 10, 1), "Toussaint", "All Saints’ Day"], [Date.UTC(a, 10, 11), "Armistice", "Armistice Day"],
     [Date.UTC(a, 11, 25), "Noël", "Christmas Day"]].forEach(function (x) { f[x[0]] = { fr: x[1], en: x[2] }; });
    return (feries[a] = f);
  }
  // fermetures exceptionnelles, une par ligne : « 24/12 » (chaque année), « 26/12/2026 », « 01/08/2026 - 15/08/2026 Congés d'été »
  var exceptions = String(window.FERMETURES || "").split(/\n/).map(function (ligne) {
    var r = ligne.match(/^\s*(\d{1,2})[\/.](\d{1,2})(?:[\/.](\d{2,4}))?(?:\s*(?:-|–|au)\s*(\d{1,2})[\/.](\d{1,2})(?:[\/.](\d{2,4}))?)?\s*[:(–-]?\s*(.*?)\)?\s*$/);
    if (!r) return null;
    var an = function (x) { return x ? (x.length === 2 ? 2000 + +x : +x) : null; };
    return { j1: +r[1], m1: +r[2], a1: an(r[3]), j2: +(r[4] || r[1]), m2: +(r[5] || r[2]), a2: an(r[6]) || an(r[3]), nom: r[7] };
  }).filter(Boolean);
  function fermeture(t) {
    var a = new Date(t).getUTCFullYear(), f = joursFeries(a)[t];
    if (f) return f;
    for (var i = 0; i < exceptions.length; i++) {
      var e = exceptions[i], debut, fin;
      if (e.a1) { debut = Date.UTC(e.a1, e.m1 - 1, e.j1); fin = Date.UTC(e.a2 || e.a1, e.m2 - 1, e.j2); if (fin < debut) fin = Date.UTC((e.a2 || e.a1) + 1, e.m2 - 1, e.j2); }
      else {   // sans année : chaque année (une période peut passer le 31 décembre)
        debut = Date.UTC(a, e.m1 - 1, e.j1); fin = Date.UTC(a, e.m2 - 1, e.j2);
        if (fin < debut) { if (t <= fin) debut = Date.UTC(a - 1, e.m1 - 1, e.j1); else fin = Date.UTC(a + 1, e.m2 - 1, e.j2); }
      }
      if (t >= debut && t <= fin) return { fr: e.nom, en: "" };   // nom écrit en français : pas repris en anglais
    }
    return null;
  }
  function creneaux(d) { return fermeture(auj + d * JOUR) ? [] : H[(jour + d) % 7] || []; }
  var fermeAuj = (H[jour] || []).length ? fermeture(auj) : null;   // un lundi férié reste un simple jour de fermeture

  var ouvert = null, prochain = null;
  creneaux(0).forEach(function (c) { if (min >= c[0] && min < c[1]) ouvert = c; });
  if (!ouvert) for (var d = 0; d < 400 && !prochain; d++) {
    creneaux(d).forEach(function (c) { if (!prochain && (d > 0 || c[0] > min)) prochain = { j: (jour + d) % 7, d: d, c: c }; });
  }
  function heure(m, l) {
    if (l === "en") { var h = Math.floor(m / 60); return ((h + 11) % 12 + 1) + (m % 60 ? ":" + String(m % 60).padStart(2, "0") : "") + (h < 12 ? "am" : "pm"); }
    return Math.floor(m / 60) + "h" + (m % 60 ? String(m % 60).padStart(2, "0") : "");
  }
  function date(t, l) { return new Intl.DateTimeFormat(l === "en" ? "en-GB" : "fr-FR", { timeZone: "UTC", weekday: "long", day: "numeric", month: "long" }).format(t); }
  function statut(l) {
    if (ouvert) return l === "en" ? "Open now · until " + heure(ouvert[1], l) : "Ouvert maintenant · jusqu’à " + heure(ouvert[1], l);
    if (!prochain) return "";
    var quand = prochain.d === 0 ? (l === "en" ? "at " : "à ") : prochain.d === 1 ? (l === "en" ? "tomorrow at " : "demain à ")
      : prochain.d < 7 ? JOURS[l][prochain.j] + (l === "en" ? " at " : " à ") : (l === "en" ? "on " : "le ") + date(auj + prochain.d * JOUR, l) + (l === "en" ? " at " : " à ");
    return (l === "en" ? "Closed" : "Fermé") + (fermeAuj && fermeAuj[l] ? " (" + fermeAuj[l] + ")" : "") + (l === "en" ? " · opens " : " · ouvre ") + quand + heure(prochain.c[0], l);
  }
  function majStatut() {
    var t = statut(langue);
    if (!t) return;
    document.querySelectorAll("[data-statut]").forEach(function (el) { el.textContent = t; if (ouvert) el.setAttribute("data-ouvert", ""); });
    var a = document.querySelector("[data-annonce]");
    if (a) a.textContent = t;
    document.querySelectorAll("[data-pastille]").forEach(function (p) { p.className = "pastille " + (ouvert ? "pastille--ouvert" : "pastille--ferme"); });
  }
  // tableaux des horaires : ligne « Jours fériés · Fermé », puis les fermetures des 14 prochains jours
  document.querySelectorAll(".horaires tbody").forEach(function (corps) {
    var ferme = Array.prototype.find.call(corps.querySelectorAll("td"), function (td) { return !/\d/.test(td.textContent); });
    var motFerme = ferme ? ferme.textContent.trim() : (langue === "en" ? "Closed" : "Fermé");
    function ligne(titre, texte, aujourdhui) {
      var tr = document.createElement("tr"), th = document.createElement("th"), td = document.createElement("td");
      th.scope = "row"; th.textContent = titre; td.textContent = texte;
      if (aujourdhui) tr.setAttribute("data-aujourdhui", "");
      tr.appendChild(th); tr.appendChild(td); corps.appendChild(tr);
    }
    ligne(langue === "en" ? "Public holidays" : "Jours fériés", motFerme);
    for (var d = 0; d < 14; d++) {
      var f = fermeture(auj + d * JOUR);
      if (f && (H[(jour + d) % 7] || []).length) {
        var titre = date(auj + d * JOUR, langue);
        ligne(titre.charAt(0).toUpperCase() + titre.slice(1), motFerme + (f[langue] ? " (" + f[langue] + ")" : ""), d === 0);
      }
    }
  });
  if (!fermeAuj) document.querySelectorAll('.horaires tr[data-jour="' + jour + '"]').forEach(function (tr) { tr.setAttribute("data-aujourdhui", ""); });

  // --- langue FR / EN (textes marqués data-en ; les fiches produit restent en français dans la maquette)
  function appliquerLangue(l) {
    langue = l;
    doc.lang = l;
    document.querySelectorAll("[data-en]").forEach(function (el) {
      if (el.dataset.fr === undefined) el.dataset.fr = el.innerHTML;
      el.innerHTML = l === "en" ? el.dataset.en : el.dataset.fr;
    });
    document.querySelectorAll("[data-en-placeholder]").forEach(function (el) {
      if (el.dataset.frPlaceholder === undefined) el.dataset.frPlaceholder = el.placeholder;
      el.placeholder = l === "en" ? el.dataset.enPlaceholder : el.dataset.frPlaceholder;
    });
    document.querySelectorAll("[data-en-label]").forEach(function (el) {
      if (el.dataset.frLabel === undefined) el.dataset.frLabel = el.getAttribute("aria-label");
      el.setAttribute("aria-label", l === "en" ? el.dataset.enLabel : el.dataset.frLabel);
    });
    document.querySelectorAll("[data-langue]").forEach(function (b) { b.setAttribute("aria-checked", l === "en" ? "true" : "false"); });
    majStatut();
    memo.set("langue", l);
  }
  majStatut();   // Shopify : le bouton FR/EN envoie le formulaire de langue
  doc.classList.remove("en-attente");

  // --- menu « ⋯ » (tiroir à droite)
  var tiroir = document.getElementById("tiroir"), ouvrir = document.querySelector("[data-ouvrir-tiroir]"), dernierFocus = null;
  function fermerTiroir() {
    if (!tiroir || tiroir.hidden) return;
    tiroir.classList.remove("tiroir--ouvert");
    ouvrir.setAttribute("aria-expanded", "false");
    setTimeout(function () { tiroir.hidden = true; }, 280);
    document.body.style.overflow = "";
    if (dernierFocus) dernierFocus.focus();
  }
  if (tiroir && ouvrir) {
    ouvrir.addEventListener("click", function () {
      dernierFocus = document.activeElement;
      tiroir.hidden = false;
      requestAnimationFrame(function () { tiroir.classList.add("tiroir--ouvert"); });
      ouvrir.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      tiroir.querySelector(".tiroir__fermer").focus();
    });
    tiroir.querySelectorAll("[data-fermer-tiroir]").forEach(function (b) { b.addEventListener("click", fermerTiroir); });
    document.addEventListener("keydown", function (ev) {
      if (tiroir.hidden) return;
      if (ev.key === "Escape") fermerTiroir();
      if (ev.key === "Tab") { // le focus reste dans le menu
        var f = tiroir.querySelectorAll("a[href], button"), premier = f[0], dernier = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === premier) { ev.preventDefault(); dernier.focus(); }
        else if (!ev.shiftKey && document.activeElement === dernier) { ev.preventDefault(); premier.focus(); }
      }
    });
  }

  // --- grand menu « Nos produits » (ordinateur) : s'ouvre au survol, ou avec le bouton flèche (clavier, toucher) ; Échap ferme
  var boutonMega = document.querySelector("[data-mega]"), mega = document.getElementById("mega");
  if (boutonMega && mega) {
    var basculer = function (ouvrir) {
      mega.classList.toggle("mega--ouvert", ouvrir);
      boutonMega.setAttribute("aria-expanded", ouvrir ? "true" : "false");
    };
    boutonMega.addEventListener("click", function () { basculer(boutonMega.getAttribute("aria-expanded") !== "true"); });
    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && mega.classList.contains("mega--ouvert")) { basculer(false); boutonMega.focus(); }
    });
    document.addEventListener("click", function (ev) { if (!ev.target.closest(".menu__item--mega")) basculer(false); });
    mega.parentNode.addEventListener("focusout", function (ev) { if (!ev.relatedTarget || !mega.parentNode.contains(ev.relatedTarget)) basculer(false); });
  }

  // --- introduction : l'animation d'origine du site Wix (l'abeille vole, se pose, le logo se secoue, le nom tombe),
  // l'abeille vole derrière le texte puis le logo se pose à côté du titre (ordinateur) ou au-dessus (téléphone), une seule fois
  var abeille = document.querySelector("[data-abeille]");
  if (abeille) (function () {
    var boite = abeille.parentNode, hero = boite.parentNode, texte = hero.querySelector(".hero__texte");
    var calme = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // le logo final et son nom doivent rester lisibles (Robin, 28/09) : ils se posent là où il n'y a pas de texte ;
    // l'abeille, elle, vole aussi derrière le texte. Dans l'image, logo + nom = 48 % de la largeur, du 21 % au 78 % de la hauteur.
    function placer() {
      var h = hero.getBoundingClientRect(), r = texte.getBoundingClientRect(), taille, x, y;
      if (h.width >= 800) {   // ordinateur : dans l'espace libre entre le grand titre et la photo
        var titre = texte.querySelector("h1"), intro = texte.querySelector(".hero__intro"), photo = hero.querySelector(".hero__visuel").getBoundingClientRect();
        var plage = document.createRange(), droite = 0;
        plage.selectNodeContents(titre);
        [].forEach.call(plage.getClientRects(), function (l) { droite = Math.max(droite, l.right); });
        var haut = titre.getBoundingClientRect().top + 4, bas = intro.getBoundingClientRect().top - 10;
        taille = Math.max(240, Math.min((photo.left - droite - 8) / 0.48, (bas - haut) / 0.57, 620));
        x = (droite + photo.left) / 2 - h.left; y = haut - h.top + taille * 0.29;
      } else {                // téléphone : dans l'espace réservé au-dessus du texte (padding-top de .hero__texte)
        var reserve = parseFloat(getComputedStyle(texte).paddingTop) || 200;
        taille = reserve / 0.66;
        x = r.left + r.width / 2 - h.left; y = r.top - h.top + taille * 0.3;
      }
      boite.style.width = taille.toFixed(0) + "px";
      boite.style.transform = "translate(" + (x - taille / 2).toFixed(0) + "px, " + (y - taille / 2).toFixed(0) + "px)";
    }
    placer();
    var redim = null;
    window.addEventListener("resize", function () { clearTimeout(redim); redim = setTimeout(placer, 150); });
    var lancer = function () { abeille.src = calme ? abeille.dataset.fin : abeille.dataset.anim; };
    var demarrer = function () {
      if (calme || !("IntersectionObserver" in window)) return lancer();
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); setTimeout(lancer, 400); } }, { threshold: 0.5 });
      io.observe(boite);
    };
    if (document.readyState === "complete") setTimeout(demarrer, 200);
    else window.addEventListener("load", function () { setTimeout(demarrer, 200); });
  })();

  // --- questions fréquentes : un lien vers une question (faq.html#q-…) ouvre directement sa réponse
  function ouvrirQuestion() {
    var q = location.hash && document.getElementById(location.hash.slice(1));
    if (q && q.tagName === "DETAILS") { q.open = true; q.scrollIntoView({ block: "center" }); }
  }
  ouvrirQuestion();
  window.addEventListener("hashchange", ouvrirQuestion);

  // --- avis : défilement continu et fluide (la liste est doublée pour boucler sans à-coup)
  document.querySelectorAll("[data-avis]").forEach(function (piste) {
    // ordre mélangé à chaque visite (puis la liste est de nouveau doublée pour boucler)
    var originaux = [].filter.call(piste.children, function (c) { return !c.hasAttribute("aria-hidden"); });
    for (var k = originaux.length - 1; k > 0; k--) { var m = Math.floor(Math.random() * (k + 1)), x = originaux[k]; originaux[k] = originaux[m]; originaux[m] = x; }
    piste.textContent = "";
    originaux.forEach(function (c) { piste.appendChild(c); });
    originaux.forEach(function (c) { var d = c.cloneNode(true); d.setAttribute("aria-hidden", "true"); piste.appendChild(d); });
    var section = piste.closest(".avis"), vitesse = 2.7, pause = false, visible = true, glisse = null, reprise = null;
    var calme = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var moitie = function () { return piste.scrollWidth / 2; };
    var boucle = function () {
      if (piste.scrollLeft >= moitie()) piste.scrollLeft -= moitie();
      if (piste.scrollLeft < 0) piste.scrollLeft += moitie();
    };
    var pos = 0;
    function image() {
      if (visible && !pause && !calme && !glisse) { pos += vitesse; if (pos >= 1) { piste.scrollLeft += Math.floor(pos); pos -= Math.floor(pos); boucle(); } }
      requestAnimationFrame(image);
    }
    var arreter = function () { pause = true; clearTimeout(reprise); };
    var relancer = function (delai) { clearTimeout(reprise); reprise = setTimeout(function () { pause = false; }, delai || 0); };
    section.addEventListener("mouseenter", arreter);
    section.addEventListener("mouseleave", function () { relancer(300); });
    section.addEventListener("focusin", arreter);
    section.addEventListener("focusout", function (ev) { if (!section.contains(ev.relatedTarget)) relancer(300); });
    piste.addEventListener("touchstart", arreter, { passive: true });
    piste.addEventListener("touchend", function () { boucle(); relancer(2500); }, { passive: true });
    piste.addEventListener("scroll", function () { if (pause) boucle(); }, { passive: true });
    // glisser à la souris
    piste.addEventListener("pointerdown", function (ev) { if (ev.pointerType !== "mouse") return; glisse = { x: ev.clientX, s: piste.scrollLeft }; piste.setPointerCapture(ev.pointerId); });
    piste.addEventListener("pointermove", function (ev) { if (glisse) { piste.scrollLeft = glisse.s - (ev.clientX - glisse.x); boucle(); } });
    piste.addEventListener("pointerup", function () { glisse = null; });
    var pas = function () { var c = piste.querySelector(".avis__carte"); return c ? c.getBoundingClientRect().width + 16 : 300; };
    var deplacer = function (sens) { piste.scrollBy({ left: sens * pas(), behavior: "smooth" }); setTimeout(boucle, 450); };
    section.querySelector("[data-avis-suivant]").addEventListener("click", function () { deplacer(1); });
    section.querySelector("[data-avis-precedent]").addEventListener("click", function () { deplacer(-1); });
    piste.addEventListener("keydown", function (ev) {
      if (ev.key === "ArrowRight") { ev.preventDefault(); deplacer(1); }
      if (ev.key === "ArrowLeft") { ev.preventDefault(); deplacer(-1); }
    });
    // démarre tout de suite ; mis en pause seulement quand le carrousel sort de l'écran
    if ("IntersectionObserver" in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(piste);
    requestAnimationFrame(image);
  });

  // --- plan Google Maps : chargé automatiquement quand on approche de la zone (page plus rapide au démarrage)
  document.querySelectorAll("iframe[data-src]").forEach(function (f) {
    var charger = function () { if (!f.src) f.src = f.dataset.src; };
    if (!("IntersectionObserver" in window)) return charger();
    var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { charger(); io.disconnect(); } }, { rootMargin: "300px" });
    io.observe(f);
  });

  // --- tri des collections
  var tri = document.querySelector("[data-tri]"), grille = document.querySelector("[data-grille]");
  if (tri && grille) tri.addEventListener("change", function () {
    var items = Array.prototype.slice.call(grille.children), v = tri.value;
    items.sort(function (a, b) {
      if (v === "nom") return a.dataset.nom.localeCompare(b.dataset.nom, "fr");
      var pa = parseFloat(a.dataset.prix) || Infinity, pb = parseFloat(b.dataset.prix) || Infinity;
      return v === "prix-asc" ? pa - pb : (pb === Infinity ? -1 : pa === Infinity ? 1 : pb - pa);
    });
    items.forEach(function (li) { grille.appendChild(li); });
  });

  // --- galerie fiche produit
  var principale = document.querySelector("[data-principale]");
  document.querySelectorAll(".galerie__vignette").forEach(function (b, i) {
    if (i === 0) b.setAttribute("aria-current", "true");
    b.addEventListener("click", function () {
      principale.src = b.dataset.src; principale.removeAttribute("width"); principale.removeAttribute("height");
      document.querySelectorAll(".galerie__vignette").forEach(function (x) { x.removeAttribute("aria-current"); });
      b.setAttribute("aria-current", "true");
    });
  });

  // --- recherche (index chargé par recherche.js) : le nom du produit passe avant le rayon ou la référence
  var res = document.querySelector("[data-resultats]");
  if (res) window.addEventListener("load", function () {
    var q = (new URLSearchParams(location.search).get("q") || "").trim();
    document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = q; });
    var norm = function (s) { return s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); };
    var mots = norm(q).split(/\s+/).filter(Boolean);
    var resume = document.querySelector("[data-resume]");
    if (!mots.length) return;
    var trouve = (window.INDEX || []).map(function (p) {
      var nom = norm(p[0]), tout = nom + " " + norm(p[2]) + " " + norm(p[5]);
      if (!mots.every(function (m) { return tout.indexOf(m) > -1; })) return null;
      return { p: p, s: mots.filter(function (m) { return nom.indexOf(m) > -1; }).length * 10 + (nom.indexOf(mots[0]) === 0 ? 5 : 0) };
    }).filter(Boolean).sort(function (a, b) { return b.s - a.s || a.p[0].localeCompare(b.p[0], "fr"); }).map(function (x) { return x.p; });
    var en = langue === "en";
    resume.textContent = trouve.length
      ? trouve.length + (en ? " result" + (trouve.length > 1 ? "s" : "") + " for “" + q + "”" : " résultat" + (trouve.length > 1 ? "s" : "") + " pour « " + q + " »")
      : (en ? "No results for “" + q + "”. Try another word, or call us on +33 2 41 74 04 56." : "Aucun résultat pour « " + q + " ». Essayez un autre mot, ou appelez-nous au 02 41 74 04 56.");
    var esc = function (s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; };
    res.innerHTML = trouve.slice(0, 120).map(function (p) {
      return '<li class="carte"><a href="produits/' + p[1] + '.html"><div class="carte__visuel"><img src="assets/' + p[4] + '" alt="" loading="lazy"></div><h3 class="carte__nom">' + esc(p[0]) + '</h3><span class="ardoise">' + esc(p[3]) + "</span></a></li>";
    }).join("");
  });
})();
